import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { ActiveWorkersWoMandatoryPPEDirectService, ActiveWorkersWoMandatoryPPEDirectServiceData } from "../../services/occupationalRiskPreventionKpi/activeWorkersWoMandatoryPPEDirect.service";
import { ActiveWorkersWoMandatoryPPEDirectDetailService, ActiveWorkersWoMandatoryPPEDirectDetailServiceData, WorkerDetail } from "../../services/occupationalRiskPreventionKpi/activeWorkersWoMandatoryPPEDirectDetail.service";
import { ColumnDefinition, DateColumnDefinition, EmailColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class ActiveWorkersWoMandatoryPPEDirectDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'active-workers-wo-mandatory-ppe-direct-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class ActiveWorkersWoMandatoryPPEDirectKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<ActiveWorkersWoMandatoryPPEDirectService, ActiveWorkersWoMandatoryPPEDirectServiceData, ActiveWorkersWoMandatoryPPEDirectServiceData, ActiveWorkersWoMandatoryPPEDirectDetailService, ActiveWorkersWoMandatoryPPEDirectDetailServiceData, ActiveWorkersWoMandatoryPPEDirectDetailData>
    implements OnDestroy {
    public getClassName() { return "ActiveWorkersWoMandatoryPPEDirectKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: ActiveWorkersWoMandatoryPPEDirectService, detailService: ActiveWorkersWoMandatoryPPEDirectDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: ActiveWorkersWoMandatoryPPEDirectServiceData): ActiveWorkersWoMandatoryPPEDirectServiceData {
        return data;
    }

    protected getDefaultSummaryData(): ActiveWorkersWoMandatoryPPEDirectServiceData {
        let data = new ActiveWorkersWoMandatoryPPEDirectServiceData();
        data.consultant = 0;
        data.office = 0;
        data.updateTimestamp = new Date();

        return data;
    }

    protected extractUpdateTime(data: ActiveWorkersWoMandatoryPPEDirectServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: ActiveWorkersWoMandatoryPPEDirectDetailServiceData, args: any): ActiveWorkersWoMandatoryPPEDirectDetailData {
        if (data.workers) {
            if (args && args.filter && args.filter.consultant) {
                let columnDefinitions = [
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Trabajador", null, true),
                    new TextColumnDefinition("EPI"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new TextColumnDefinition("Id Cliente", null, true),
                    new TextColumnDefinition("Id Centro \nCl.", null, true, 100),
                    new TextColumnDefinition("Id Ofi. \nCl.", null, true, 80),
                    new TextColumnDefinition("Ofi. Cliente", null, true),
                    new TextColumnDefinition("Consultor", null, true),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[10].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let worker of data.workers) {

                    data.workers.sort(function (a, b) {
                        if (a.contractFiscalName > b.contractFiscalName) {
                            return 1;
                        }
                        if (a.contractFiscalName < b.contractFiscalName) {
                            return -1;
                        }
                        return 0;
                    });

                    if (worker.userDocNumber.toUpperCase() == consultantNif) {

                        tabledata.push([
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.ppeDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName,
                            worker.userName,
                        ]);
                    }
                    else {
                        tabledata2.push([
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.ppeDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName,
                            worker.userName,
                        ]);
                    }

                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ActiveWorkersWoMandatoryPPEDirectDetailData(columnDefinitions, arrayOrdenado);
            } else {
                let columnDefinitions = this.getColumnsDefault();

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[0].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];

                data.workers = data.workers.sort(function (a, b) {
                    if (a.contractFiscalName > b.contractFiscalName) {
                        return 1;
                    }
                    if (a.contractFiscalName < b.contractFiscalName) {
                        return -1;
                    }
                    return 0;
                });

                for (let worker of data.workers) {
                    if (worker.userDocNumber.toUpperCase() == consultantNif) {

                        tabledata.push([
                            worker.userName,
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.ppeDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName
                        ]);
                    }
                    else {
                        tabledata2.push([
                            worker.userName,
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.ppeDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                            worker.clientId,
                            worker.clientCenterId,
                            worker.clientBranchId,
                            worker.clientBranchName
                        ]);
                    }

                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ActiveWorkersWoMandatoryPPEDirectDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: WorkerDetail[]): { userDocNumber: string, name: string }[] {
        let userDocNumbers: { userDocNumber: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!userDocNumbers.find(y => x.userDocNumber.toUpperCase() == y.userDocNumber)) userDocNumbers.push({ userDocNumber: x.userDocNumber.toUpperCase(), name: x.userName });
            })
        }

        return userDocNumbers;
    }

    protected getDefaultDetailData(): ActiveWorkersWoMandatoryPPEDirectDetailData {
        let columnDefinitions = this.getColumnsDefault();

        return new ActiveWorkersWoMandatoryPPEDirectDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }

    /**
     * Método que define las columnas, sus etiquetas y medidas
     * @returns Arreglo de columnas por defecto para la grilla
     */
    public getColumnsDefault(): any {
        let columnDefinitions = [
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Cliente", null, true),
            new TextColumnDefinition("Trabajador", null, true),
            new TextColumnDefinition("EPI"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
            new TextColumnDefinition("Id Cliente", null, true),
            new TextColumnDefinition("Id Centro \nCl.", null, true, 100),
            new TextColumnDefinition("Id Ofi. \nCl.", null, true, 80),
            new TextColumnDefinition("Ofi. Cliente", null, true),
        ];

        return columnDefinitions;
    }
}
